module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-motivation-getting-help-large@3x.b1494e62.png";